import "./Topbar.css";
import React from "react";
import { useNavigate, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { FaBars, FaGem } from "react-icons/fa";
import logoDefault from "../../assets/logo.png";
import logoLR from "../../assets/logoLR1.png";
import logoCEC from "../../assets/logoCEC.png";
import { logoutUser } from "../../redux/apiCalls/loginCall";
import { userSuccess } from "../../redux/reducers/profileReducer";

const Topbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector((state) => state.user.currentUser);
  const companyConfig = {
    22: {
      logo: logoLR,
      isCompact: true,
    },
    21: {
      logo: logoCEC,
      isCompact: true,
    },
  };
  const companyId = Number(user?.company);
  const currentCompany = companyConfig[companyId];

  const handleLogout = () => {
    dispatch(userSuccess(null));
    localStorage.removeItem("downloadData");
    localStorage.removeItem("selectedCompanies");
    localStorage.removeItem("selectedDevices");
    localStorage.removeItem("board");
    logoutUser(dispatch, user?.accessToken, { user: user?.user });
    navigate("/login");
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light navbar-app">
      <label
        className={
          currentCompany?.isCompact
            ? "navbar-brand image-logo-small"
            : "navbar-brand image-logo"
        }
        onClick={() => navigate("/")}
      >
        <img
          src={currentCompany?.logo || logoDefault}
          alt="Logo bill system"
          width={currentCompany?.isCompact ? "80px" : "200px"}
          height={currentCompany?.isCompact ? "50px" : "45px"}
        />
        <p className="nav-item">ENERGY BILL MANAGER</p>
      </label>
      {user && location.pathname !== "/expired-password" ? (
        <div className="navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item dropdown">
              <label
                className="nav-link nav-link-custom dropdown-toggle topbar-dropdown"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i>
                  <FaBars />
                </i>
              </label>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="navbarDropdown"
                style={{ position: "absolute" }}
              >
                {user.privilege === "editor" || user.privilege === "master" ? (
                  <li>
                    <label
                      className="dropdown-item"
                      onClick={() => navigate("/uploadBill")}
                    >
                      Cargar factura
                    </label>
                  </li>
                ) : null}
                {["admin", "master", "editor"].includes(user.privilege) ? (
                  <li>
                    <label
                      className="dropdown-item"
                      onClick={() =>
                        navigate(
                          user.privilege === "editor"
                            ? "/admin/lists?show=companies"
                            : "/admin/lists?show=users"
                        )
                      }
                    >
                      Administrar
                    </label>
                  </li>
                ) : null}
                <li>
                  <label
                    className="dropdown-item"
                    onClick={() => navigate("/admin/audit")}
                  >
                    Auditoría
                  </label>
                </li>
                <li className="dropdown-item-icon">
                  <label
                    onClick={() => navigate("/insights")}
                  >
                    Informes
                  </label>
                  <span className="dropdown-item-span" title="Prueba gratuita por 10 días">
                    <FaGem />
                  </span>
                </li>
                <li>
                  <label
                    className="dropdown-item"
                    onClick={() => navigate(`profile/${user.id_user}`)}
                  >
                    Tu cuenta
                  </label>
                </li>
                <li>
                  <label
                    className="dropdown-item"
                    onClick={() => navigate(`pass/${user.id_user}`)}
                  >
                    Contraseña
                  </label>
                </li>
                <li>
                  <label className="dropdown-item" onClick={handleLogout}>
                    Cerrar sesión
                  </label>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      ) : null}
    </nav>
  );
};

export default Topbar;
